import {connect, useSelector} from "react-redux";
import {RouteComponentProps} from "react-router";
import styled from "@emotion/styled";
import {css} from "@linaria/core";
import {Breadcrumbs} from "@rw/breadcrumbs";
import {pluralize} from "@rw/string_utils";

import {appLink} from "../../../../../../packages/utils/cars_routes";
import {IStore} from "../../../app/reducers/hybrid_reducer";
import {getVoivodeshipLocativeName} from "../../../app/types/locationTypes";
import {CarMakeTypes} from "../../../cars_data/cars_data";
import {Container} from "../../../homepage/components/CarBrandsSection";
import {ICarListOfferResponse} from "../../../meta_data/reducers/meta_data_reducer";
import {getOfferListUrl} from "../url_utils/get_offer_list_url";
import {capitalizeFirstLetter} from "../utils/capitalize_first_letter";
import {formatMakeDisplayName} from "../utils/format_make_display_name";
import {IBreadcrumb} from "./breadcrumb_types";
import {CarList} from "./CarList";
import {CarListFilters} from "./CarListFilters";
import {SeoLocationLinks} from "./SeoLocationLinks";

export {capitalizeFirstLetter} from "../utils/capitalize_first_letter";
export type {IBreadcrumb} from "./breadcrumb_types";

const pluralOffer = pluralize(["oferta", "oferty", "ofert"]);

interface IStateProps {
    carsData: {
        //  meta: IOfferListApiResponseMeta;
        cars: ICarListOfferResponse[];

        //requestState: RequestState;
    };
    carMakeType: CarMakeTypes;
    totalPages: number;
    totalItems: number;
    currentPage: number;
}

export interface ICarsListDynamicProps extends IStateProps, RouteComponentProps<{}> {
    test?: boolean;
}

export const generateCarListBreadcrumbs = (carMakeType: CarMakeTypes) => {
    const listingBreadcrumbs: IBreadcrumb[] = [
        {
            label: "Osobowe",
            link: appLink.searchResult.universal({offerType: "osobowe"}),
            asStatic: false
        }
    ];

    if (carMakeType) {
        const carTypeBreadcrumb: IBreadcrumb = {
            label: formatMakeDisplayName(carMakeType),
            link: getOfferListUrl({
                offerType: "osobowe",
                type: carMakeType
            })
        };
        return [...listingBreadcrumbs, carTypeBreadcrumb];
    }

    return listingBreadcrumbs;
};

export const CarListDynamicC = (props: ICarsListDynamicProps) => {
    const breadcrumbsData = generateCarListBreadcrumbs(props.carMakeType);
    const location = useSelector((store: IStore) => store.carList.location.location);
    const locationPLName = useSelector((store: IStore) => store.carList.locationPLName);

    const renderH1Title = () => {
        const make = formatMakeDisplayName(props.carMakeType);
        const countSuffix =
            props.totalItems > 0 ? ` — ${props.totalItems} ${pluralOffer(props.totalItems)}` : "";

        if (location?.subLocation) {
            const city = locationPLName?.cityName || capitalizeFirstLetter(location.subLocation);
            if (make) {
                return `Samochody osobowe ${make} w ${city}${countSuffix}`;
            }
            return `Samochody osobowe w ${city}${countSuffix}`;
        }

        if (location?.location) {
            const voivodeship =
                getVoivodeshipLocativeName(location.location) || capitalizeFirstLetter(location.location);
            if (make) {
                return `Samochody osobowe ${make} w ${voivodeship}${countSuffix}`;
            }
            return `Samochody osobowe w ${voivodeship}${countSuffix}`;
        }

        if (make) {
            return `Samochody osobowe ${make}${countSuffix}`;
        }

        return `Samochody osobowe${countSuffix}`;
    };

    return (
        <div className={listingHolder}>
            <div className={pageHolder}>
                <Container>
                    <CarListBreadcrumbs breadcrumbs={breadcrumbsData} />
                    <h1>{renderH1Title()}</h1>
                    <CarListFilters />
                    <CarList
                        cars={props.carsData.cars}
                        totalPages={props.totalPages}
                        totalItems={props.totalItems}
                        currentPage={props.currentPage}
                        carMakeType={props.carMakeType}
                    />
                    <SeoLocationLinks />
                </Container>
            </div>
        </div>
    );
};

function mapStateToProps(state: IStore): IStateProps {
    return {
        carsData: state.carList.cars,
        totalPages: state.carList.cars.totalPages,
        totalItems: state.carList.cars.totalItems,
        currentPage: state.carList.cars.currentPage,
        carMakeType: state.carList.latestQuery.type
    };
}

export const CarListDynamic = connect(mapStateToProps, null)(CarListDynamicC);

const listingHolder = css`
    position: relative;

    padding: 0 2rem;

    @media (min-width: 1230px) {
        padding: 0;
    }
`;

const pageHolder = css`
    position: relative;
    width: 100%;
`;
const CarListBreadcrumbs = styled(Breadcrumbs)`
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: wrap;
`;
